import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
export default function save({
  attributes
}) {
  const {
    ordered,
    type,
    reversed,
    start
  } = attributes;
  const TagName = ordered ? 'ol' : 'ul';
  return createElement(TagName, {
    ...useBlockProps.save({
      type,
      reversed,
      start
    })
  }, createElement(InnerBlocks.Content, null));
}
//# sourceMappingURL=save.js.map